<template>
  <li class="nav-item my-auto ml-2 dropdown" v-click-outside="onOutsideClick">
    <a
      class="nav-link"
      @click="open = !open"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div class="position-relative clickable">
        <icon
          name="Bell"
          :class="{ 'icon-primary': unreadCount > 0 }"
          size="sm"
        />
        <span
          class="badge badge-primary badge-circle position-absolute count"
          v-show="unreadCount > 0"
          >{{ unreadCount }}</span
        >
      </div>
    </a>
    <div
      class="dropdown-menu dropdown-menu-right px-0 pt-2 pb-0"
      :class="{ show: open }"
      aria-labelledby="navbarDropdown"
    >
      <p class="h5">Notifiche</p>
      <notifications
        @count="unreadNotificationsCount"
        :open="open"
        @read="decreaseUnreadCount"
      />
    </div>
  </li>
</template>

<script lang="ts">
import { Vue, Component, Mixins, Watch } from "vue-property-decorator";
import Notifications from "components/Notification/List.vue";
import ClickOutside from "directives/ClickOutside";
import { RequestData } from "store/types";
import ActivityRecipientsMixin from "mixins/http/ActivityRecipientsMixin";
import { RegisterHttp } from "utils/Decorators";
import { Getter } from "vuex-class";
import Icon from "components/Icon.vue";

@Component({
  components: {
    Icon,
    Notifications,
  },
  directives: {
    ClickOutside,
  },
})
export default class NotificationsDropdown extends Mixins(
  ActivityRecipientsMixin,
) {
  @Getter currentUser;

  open: boolean = false;
  unreadCount: number = 0;

  unreadNotificationsCount(val) {
    this.unreadCount = val;
  }

  decreaseUnreadCount() {
    this.unreadCount -= 1;
  }

  onOutsideClick() {
    if (this.open) this.open = false;
  }
}
</script>

<style scoped>
.dropdown-menu {
  width: 245px !important;
  height: 300px !important;
  overflow-y: auto;
}

.count {
  width: 16px !important;
  height: 16px !important;
  font-size: 0.6rem !important;
  line-height: 16px !important;
  left: 8px;
  bottom: 8px;
}
</style>
